import React from 'react';

const Massachusetts = () => {
  return (
    <div>
      
    </div>
  );
}

export default Massachusetts;
